import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import LeftHeading from '../../../../Components/Accounts/LeftHeading/LeftHeading'
import MultiItemsGrid from '../../../../Components/Accounts/MultiItemsGrid/MultiItemsGrid'
import Section from '../../../../Components/Section/Section'
import { getResponseError, getUserDetailsCookie } from '../../../../Api/Utils/apiUtils'
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert'
import SupplierCard from '../../../../Components/Accounts/Supplier/SupplierCard/SupplierCard'
import EventApi from '../../../../Api/EventApi'
import ScaleLoader from "react-spinners/ScaleLoader";

const FavouriteSupplierComponent = () => {

    const [errorMessage, setErrorMessage] = useState(null);
    const [favoriteSupplier, setfavoriteSupplier] = useState([])
    const [customerId, setcustomerId] = useState(null)
    const [isloading, setisloading] = useState(true)

    useEffect(() => {
        const loadFavoritesupplier = async () => {
            const user = getUserDetailsCookie();
            setcustomerId(user.id)
            const favorit = await EventApi.getFavoriteSupplierList(user.id)//30853
            const responseApiError = getResponseError(favorit)
            if (responseApiError) {
                setErrorMessage(responseApiError)
                setisloading(false)
            }else{
                const favoriteSupplierList = favorit.objectVal
                setfavoriteSupplier(favoriteSupplierList)
                setisloading(false)
            }
        } 
        loadFavoritesupplier()
    }, [])
    return (
        <>
        {isloading ? 
        <div className="loading-section">
            <ScaleLoader color={'#591EC1'} loading={isloading} size={40} />
        </div>
        :
        <Section contStyle={{minHeight: "90vh"}}>
            <Container>
                <LeftHeading>Favourite suppliers</LeftHeading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <MultiItemsGrid itemsPerRow={3}>
                    {/* that should inside array map */
                    favoriteSupplier && favoriteSupplier.length > 0 &&  
                    favoriteSupplier.map((supplier, i) => (
                        <SupplierCard key={i} supplierInfo={supplier} customerId={customerId} />
                            
                    ))}
                </MultiItemsGrid>
            </Container>
        </Section>}
        </>
    )
}

export default FavouriteSupplierComponent
